<template>
  <v-app id="marketScout">
    
    <AppHeader />
    
    <v-content>
      <router-view/>
    </v-content>

    <AppFooter />
  
    <notifications position="bottom right" />
  </v-app>
</template>

<script>
  export default {
    name: 'App',

    data: function() {
      return {};
    },

    components: {
      //AppHeader,
      //AppFooter
      AppHeader: () => import("@/components/layout/AppHeader"),
      AppFooter: () => import("@/components/layout/AppFooter")
    }
  }
</script>